// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds.
const debounce = <T extends Function>(func: T, wait: number) => {
	let timeout: ReturnType<typeof setTimeout>

	return (...args: unknown[]) => {
		const context = this
		clearTimeout(timeout)
		timeout = setTimeout(() => func.apply(context, args), wait)
	}
}

export default debounce
